import React from "react";
import { Button, Box } from "@mui/material";
import { useStore } from "../../app/stores/store";
import DataTable, { DataType, FilterProps } from "../../app/common/DataTable";
import { useTranslation } from "react-i18next";
import PaymentForm from "../payments/PaymentForm";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmComponent from "../../app/common/form/ConfirmComponent";
import {
  usePaymentMethodOptions,
  usePaymentTypeOptions,
} from "../../app/common/enums/paymentType";

export default function MemberPayments() {
  const { t } = useTranslation();
  const { selectedMember } = useStore((s) => s.memberStore);
  const paymentStore = useStore((s) => s.paymentStore);
  const modalStore = useStore((s) => s.modalStore);
  const paymentMethodOptions = usePaymentMethodOptions();
  const paymentTypeOptions = usePaymentTypeOptions();
  const columns = [
    {
      header: t("memberPayments.columns.paymentType"),
      options: paymentTypeOptions,
      dataType: DataType.SELECT,
      key: "paymentType",
      filterable: true,
    },
    {
      header: t("memberPayments.columns.paymentMethod"),
      options: paymentMethodOptions,
      dataType: DataType.SELECT,
      key: "paymentMethod",
      filterable: true,
    },
    {
      key: "paidAt",
      header: t("memberPayments.columns.paidAt"),
      dataType: DataType.DATE,
      filterable: true,
    },
    {
      key: "paidAmount",
      header: t("memberPayments.columns.paidAmount"),
      DataType: DataType.NUMBER,
      formatPrice: true,
    },
    {
      key: "reasonForPayment",
      header: t("memberPayments.columns.reasonForPayment"),
      filterable: true,
    },
    { key: "note", header: t("memberPayments.columns.note"), filterable: true },
  ];

  const handleDelete = async (id: string) => {
    await paymentStore.deletePayment(id);
    modalStore.closeModal();
  };

  const actionButtons = [
    {
      icon: <DeleteIcon color="error" />,
      onClick: (_e: React.MouseEvent, item: any) =>
        modalStore.openModal(
          <ConfirmComponent
            onYes={async () => handleDelete(item.id!)}
            onCancel={modalStore.closeModal}
          />
        ),
    },
  ];

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => modalStore.openModal(<PaymentForm />, "small")}
        >
          {t("memberPayments.addPaymentButton")}
        </Button>
      </Box>
      <DataTable
        columns={columns}
        data={paymentStore.tableData}
        onClick={(item) => {
          modalStore.openModal(<PaymentForm id={item.id} />, "small");
        }}
        actionButtons={actionButtons}
        onFilter={(filterProps: FilterProps) =>
          paymentStore.loadPaymentsForMember(selectedMember?.id || "", filterProps)
        }
        defaultOrderByColumn="paidAt"
        totalColumn="paidAmount"
      />
    </>
  );
}
